var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 6.66671L9.33319 4.00004M1.6665 14.3334L3.92275 14.0827C4.19841 14.052 4.33624 14.0367 4.46507 13.995C4.57936 13.958 4.68814 13.9058 4.78843 13.8396C4.90147 13.765 4.99953 13.667 5.19566 13.4709L13.9999 4.66671C14.7363 3.93033 14.7363 2.73642 13.9999 2.00004C13.2635 1.26366 12.0696 1.26366 11.3332 2.00004L2.52899 10.8042C2.33287 11.0004 2.2348 11.0984 2.16026 11.2114C2.09412 11.3118 2.04184 11.4205 2.00484 11.5348C1.96314 11.6636 1.94782 11.8014 1.9172 12.0771L1.6665 14.3334Z",
    stroke: "#9CA3AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayPencil);
export default __webpack_public_path__ + "static/media/gray_pencil.45267fbcb2a958e8aeebd8982055481a.svg";
export { ForwardRef as ReactComponent };